import React, {Component} from 'react';
import {connect} from 'react-redux';
import ImageAsset from 'components/views/image-asset';
import VideoAsset from 'components/views/video-asset';
import AssetInfo from 'components/views/asset-info';
import * as assetApi from "api/asset-api";
import {deleteAsset} from 'actions/asset-actions';
import {hideSpinner} from 'utils/spinner';
import store from 'store';
import _ from 'lodash';

// const preventTouchScroll = (event) => {
//     event.preventDefault();
// };


class MediaAssetContainer extends Component {

    state = {
        showModal: false,
    };


    componentDidMount() {
        hideSpinner();
    }

    openModal() {
        this.setState({showModal: true});
    };

    closeModal() {
        this.setState({showModal: false});
    };


    deleteAsset(e) {
        e.stopPropagation();
        e.preventDefault();
        const uploadStatus = this.props.uploadStatus;
        this.closeModal();
        store.dispatch(deleteAsset(this.props.assetUUID || this.props.tempUUID));
        if (uploadStatus === 'DONE' || uploadStatus === 'PROCESSING') {
            assetApi.deleteAsset(this.props.assetUUID).then((status) => {
                if (status !== 200) {
                    console.error("Error deleting asset");
                }
            }).catch(status => {
                console.error("Error deleting asset: " + status);
            });
        } else {
            if (!_.isEmpty(window.uploads) && window.uploads[this.props.creationDate]) {
                window.uploads[this.props.creationDate].abort();
            }
        }
        this.props.router.push('/');

    }

    render() {
        if (_.isEmpty(this.props)) {
            return <div/>;
        }
        const {keywords, title, caption, isVideo, isGif} = this.props;
        const shouldRenderVideo = isVideo || isGif;
        const assetInfo =  <AssetInfo title={title} caption={caption} keywords={keywords} showModal={this.state.showModal}
                                      deleteAsset={this.deleteAsset.bind(this)}
                                      openModal={this.openModal.bind(this)} closeModal={this.closeModal.bind(this)} />;
        if (shouldRenderVideo) {
            return <VideoAsset {...Object.assign({ loop: isGif }, this.props)}>
                {assetInfo}
            </VideoAsset>;
        } else {
            return <ImageAsset {...this.props}>
                {assetInfo}
            </ImageAsset>;
        }

    }
}

const mapStateToProps = function (store, ownProps) {
    let asset = _.find(store.assetsState.assets, {assetUUID: ownProps.params.id});
    if (_.isEmpty(asset)) {
        asset = _.find(store.assetsState.assets, {creationDate: +ownProps.params.id});
    }

    return {... asset};
};

export default connect(mapStateToProps)(MediaAssetContainer);

